/**
 * Sprint 48 · Smart Queue store real (reemplaza `smartQueueMock`).
 *
 * Todos los endpoints son autenticados por cookie HttpOnly + JWT socio
 * (Sprint 47 valida sesión activa).
 */
import { api } from "@/services/api";

const _handle = (err) => {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  const reason =
    typeof detail === "object" && detail?.reason
      ? detail.reason
      : typeof detail === "string"
        ? detail
        : "network";
  const message =
    typeof detail === "object" && detail?.detail
      ? detail.detail
      : typeof detail === "string"
        ? detail
        : "Error de red.";
  return { error: reason, mensaje: message, status };
};

export const joinFila = async (eventoId) => {
  try {
    const { data } = await api.post(
      `/eventos/${encodeURIComponent(eventoId)}/queue/join`
    );
    return data;
  } catch (err) {
    return _handle(err);
  }
};

export const consultarEstadoFila = async (eventoId) => {
  try {
    const { data } = await api.get(
      `/eventos/${encodeURIComponent(eventoId)}/queue/status`
    );
    return data;
  } catch (err) {
    return _handle(err);
  }
};

export const heartbeatFila = async (eventoId) => {
  try {
    const { data } = await api.post(
      `/eventos/${encodeURIComponent(eventoId)}/queue/heartbeat`
    );
    return data;
  } catch (err) {
    return _handle(err);
  }
};

// Sprint 54 · Fase A: "Terminar y asignar asistentes" cede el turno
// (lo marca COMPLETADA en backend) y libera al siguiente comprador.
export const completarTurno = async (eventoId) => {
  try {
    const { data } = await api.post(
      `/eventos/${encodeURIComponent(eventoId)}/queue/completar`
    );
    return data;
  } catch (err) {
    return _handle(err);
  }
};

export const cancelarFila = async (eventoId) => {
  try {
    const { data } = await api.post(
      `/eventos/${encodeURIComponent(eventoId)}/queue/cancel`
    );
    return data;
  } catch (err) {
    return _handle(err);
  }
};
